import {getNodeAttrs} from './getNodeAttrs'
export const traverseSchema = (node, parent, parentNodeType = ['Stage', 'Layer', 'Group']) => {
  node
    .getChildren()
    .toArray()
    .forEach((el) => {
      const child = {}
      child.type = parentNodeType.indexOf(el.getClassName()) > -1
        ? el.getClassName()
        : el.getAttr('shapeType')
      if (
        parentNodeType.indexOf(el.getType()) > -1 &&
        el.getClassName() !== 'Transformer'
      ) {
        child.children = []
        parent.children.push(child)
        child.attrs = el.getAttrs()
        traverseSchema(el, child)
      } else if (child.type && child.type !== 'anchor') {
        child.attrs = getNodeAttrs(el, child.type, node)
        parent.children.push(child)
      }
    })
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/traverseSchema.js